import React from "react";
import { Form, Input, Button, Card, Typography } from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { defaultFaqs } from "./defaults";
import type { SectionMeta } from "./types";

const { Text } = Typography;

export const meta: SectionMeta = {
  key: "faqs",
  label: "FAQs",
  icon: <QuestionCircleOutlined />,
  color: "#f59e0b",
  desc: "Frequently asked questions and answers",
};

export const defaultData = defaultFaqs;

export const Preview: React.FC<{ data: any[] }> = ({ data }) => {
  if (data.length === 0) return null;
  return (
    <div className="space-y-1">
      {data.slice(0, 3).map((item: any, i: number) => (
        <div key={i} className="flex gap-2 text-sm px-2 py-1">
          <span className="text-amber-500 font-mono text-xs mt-0.5 shrink-0">
            Q{i + 1}.
          </span>
          <div className="min-w-0 flex-1">
            <span className="text-gray-800 font-medium">{item.question}</span>
            <Text type="secondary" className="text-xs block truncate">
              {item.answer}
            </Text>
          </div>
        </div>
      ))}
      {data.length > 3 && (
        <Text type="secondary" className="text-xs block px-2">
          +{data.length - 3} more FAQs
        </Text>
      )}
    </div>
  );
};

export const FormFields: React.FC = () => (
  <Form.List name="faqs">
    {(fields, { add, remove }) => (
      <>
        {fields.map((field) => (
          <Card
            key={field.key}
            className="!mb-3"
            size="small"
            type="inner"
            extra={
              <Button
                type="text"
                danger
                size="small"
                onClick={() => remove(field.name)}
                icon={<DeleteOutlined />}
              />
            }
          >
            <Form.Item
              {...field}
              name={[field.name, "question"]}
              label="Question"
              className="!mb-2"
              rules={[{ required: true, message: "Required" }]}
            >
              <Input placeholder="e.g. How long does delivery take?" />
            </Form.Item>
            <Form.Item
              {...field}
              name={[field.name, "answer"]}
              label="Answer"
              className="!mb-0"
              rules={[{ required: true, message: "Required" }]}
            >
              <Input.TextArea rows={3} placeholder="Write the answer..." />
            </Form.Item>
          </Card>
        ))}
        <Button
          type="dashed"
          block
          onClick={() => add()}
          icon={<PlusOutlined />}
          className="!mb-1"
        >
          Add FAQ
        </Button>
      </>
    )}
  </Form.List>
);
